import { render, staticRenderFns } from "./CardNewLocker.vue?vue&type=template&id=03f74779&"
import script from "./CardNewLocker.vue?vue&type=script&lang=js&"
export * from "./CardNewLocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports